import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_attachment_RowInterface {
 
  guid: fromDatatype.GuidDataFieldInterface;
  file_guid : fromDatatype.GuidDataFieldInterface;
  target_table_guid : fromDatatype.GuidDataFieldInterface;
  target_table_name : fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  description : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface
  
}

export class bl_sfa_attachment_RowClass implements bl_sfa_attachment_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  file_guid : fromDatatype.GuidDataFieldInterface;
  target_table_guid : fromDatatype.GuidDataFieldInterface;
  target_table_name : fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  description : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VrsnDataFieldInterface

}
